module.exports = __webpack_public_path__ + "static/media/BelmontIndoorOutdoorMap.9035567a.png";